// extracted by mini-css-extract-plugin
export default {"form":"UserReportForm_form__L+7U7","section":"UserReportForm_section__VpXec","sectionTitle":"UserReportForm_sectionTitle__kCfI0"};